import { useState } from "react";

const useInputObject = (initialValue) => {
  const [value, setValue] = useState(initialValue || {});

  const handleChange = (newValue, property) => {
    setValue((prevValue) => ({ ...prevValue, [property]: newValue }));
  };

  const update = (property, newValue) => {
    setValue((prevValue) => ({ ...prevValue, [property]: newValue }));
  };

  const updates = (newValue) => {
    setValue((prevValue) => ({ ...prevValue, ...newValue }));
  };

  return {
    Value: value,
    setValue: setValue,
    handleChange: handleChange,
    update: update,
    updates: updates,
  };
};

export default useInputObject;
